import gsap from 'gsap';
import EventDispatcher from './EventDispatcher';
import Global from './Global';
import { connect, initColyseus } from './socket';
import * as QRCode from 'qrcode';
// var QRCode = require('qrcode');

export default class QRScanner {
  constructor() {}

  init() {
    this.isChecked = true;

    this.events = EventDispatcher.getObj();
    this.events.addEventListener('LOADER_EVENTS', this.onEvents.bind(this));
    this.events.addEventListener('GAME_EVENTS', this.onEvents.bind(this));
    this.events.addEventListener('GAMESCENE_EVENTS', this.onEvents.bind(this));
    // setTimeout(()=>{
    //     this.onOkay();
    // }, 1000)
  }

  onEvents(data) {
    switch (data.message.event_type) {
      case 'show_screen':
        this.showScreen(data.message.data.screenKey);
        break;
    }
  }

  showScreen(screenKey) {
    if (screenKey != 'QRScanner') return false;

    this.pageAnimation();
    this.activateQR();
  }

  pageAnimation() {
    gsap.fromTo(
      '#qrScanner_scr > .appContainer',
      { scale: 0.2, opacity: 0 },
      { scale: 1, opacity: 1, duration: 1, ease: 'power3.out' }
    );
  }

  async activateQR() {
    const connectStatus = await connect();

    if (connectStatus == 'failure') {
      alert('URL is either expired/invalid!');
    } else {
      this.showQRCode();
    }
    // alert('QR Code activated! Please scan the code to proceed.');
  }

  showQRCode() {
    // alert(Global.gameTry);
    const { baseURL } = Global;
    const player2URL = `${baseURL}?roomID=${Global.roomID}&gameTry=${
      Global.gameTry
    }&gameID=${Global.gameID}&gameKey=${
      Global.gameKey
    }&playerIndex=2&collectableType=${
      Global.collectableType == 'chocolate' ? 'hazelnut' : 'chocolate'
    }`;

    const canvas = document.querySelector('.scannerArea canvas');
    QRCode.toCanvas(canvas, player2URL, (error) => {
      if (error) console.error(error);
    });
    document.querySelector('#qrScanner_scr').classList.add('active');
  }

  hideControls() {}

  onQRScanner() {
    this.events.dispatchEvent({
      type: 'LOADER_EVENTS',
      message: {
        event_type: 'switch_page',
        data: {
          screenKey: 'QRScanner',
        },
      },
    });
  }

  onOkay() {
    document.querySelector('#qrScanner_scr').classList.remove('active');
    setTimeout(() => {
      // document.querySelector(".game_footer").classList.add("active2");
      document.querySelector('.game_timer_sec').classList.add('active');
    }, 100);
    this.events.dispatchEvent({
      type: 'GAME_EVENTS',
      message: {
        event_type: 'level_selected',
        data: {
          level: 1,
        },
      },
    });
  }
}
